const PopupActionTypes = {
  SHOW_POPUP: 'SHOW_POPUP',
  CLOSE_POPUP: 'CLOSE_POPUP',
  UPDATE_POPUP: 'UPDATE_POPUP',
};

export default PopupActionTypes;
